import { WeaTools } from 'ecCom'

export const getSensitiveWordLogForm = (params = {}) => {
	return WeaTools.callApi('/api/sensitive/getSensitiveWordLogForm', 'GET', params);
}

export const processSensitiveWordLog = (params = {}) => {
	return WeaTools.callApi('/api/sensitive/processSensitiveWordLog', 'POST', params);
}

export const hasRight = (params = {}) => {
	return WeaTools.callApi('/api/sensitive/hasRight', 'GET', params);
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/sensitiveWordProcess.js